/**
 * Converts number to itself plus its ordinal (1st, 2nd) suffix.
 *
 * @param {*} number - number
 * @return {string} string with ordinal suffix
 *
 * @example
 *
 *     getNumberWithOrdinalSuffix(25) -> '25th'
 */

const getNumberWithOrdinalSuffix = (number: number): string => {
  if (!number) return '';

  const modulusTen = number % 10;
  const modulusHundred = number % 100;

  let suffix = 'th';
  if (modulusTen === 1 && modulusHundred !== 11) {
    suffix = 'st';
  }
  if (modulusTen === 2 && modulusHundred !== 12) {
    suffix = 'nd';
  }
  if (modulusTen === 3 && modulusHundred !== 13) {
    suffix = 'rd';
  }

  return `${number}${suffix}`;
};

export default getNumberWithOrdinalSuffix;
